module.exports = __webpack_public_path__ + "static/media/icon-user-group-white.d46a299a.svg";